import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ConstructionIcon from "@mui/icons-material/Construction";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import PhishingIcon from "@mui/icons-material/Phishing";
import AndroidIcon from "@mui/icons-material/Android";
import HomeIcon from "@mui/icons-material/Home";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import AppsIcon from "@mui/icons-material/Apps";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowCircleDownOutlinedIcon from "@mui/icons-material/ArrowCircleDownOutlined";
import ArrowCircleUpOutlinedIcon from "@mui/icons-material/ArrowCircleUpOutlined";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import DeselectOutlinedIcon from "@mui/icons-material/DeselectOutlined";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import HighlightAltOutlinedIcon from "@mui/icons-material/HighlightAltOutlined";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import FaceIcon from "@mui/icons-material/Face";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExpandIcon from "@mui/icons-material/Expand";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import GridViewIcon from "@mui/icons-material/GridView";
import SplitscreenIcon from "@mui/icons-material/Splitscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import RemoveIcon from "@mui/icons-material/Remove";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import MinimizeIcon from "@mui/icons-material/Minimize";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeMuteIcon from "@mui/icons-material/VolumeMute";
import ScienceIcon from "@mui/icons-material/Science";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import BugReportIcon from "@mui/icons-material/BugReport";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import ErrorIcon from "@mui/icons-material/Error";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ScaleIcon from "@mui/icons-material/Scale";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import TextDecreaseIcon from "@mui/icons-material/TextDecrease";
import FlashlightOnIcon from "@mui/icons-material/FlashlightOn";
import FlashlightOffIcon from "@mui/icons-material/FlashlightOff";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import InventoryIcon from "@mui/icons-material/Inventory";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ReportIcon from "@mui/icons-material/Report";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CachedIcon from "@mui/icons-material/Cached";
import LocationOffIcon from "@mui/icons-material/LocationOff";
import PowerInputIcon from "@mui/icons-material/PowerInput";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FunctionsIcon from "@mui/icons-material/Functions";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import VideoStableIcon from "@mui/icons-material/VideoStable";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import DrawIcon from "@mui/icons-material/Draw";
import ViewComfyOutlinedIcon from "@mui/icons-material/ViewComfyOutlined";
import LogoDevIcon from "@mui/icons-material/LogoDev";
import PestControlIcon from "@mui/icons-material/PestControl";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import AutoDeleteIcon from "@mui/icons-material/AutoDelete";
import SignalCellularNodataIcon from "@mui/icons-material/SignalCellularNodata";
import NextPlanIcon from "@mui/icons-material/NextPlan";

export const iconMap = {
  add: AddIcon,
  eye: VisibilityIcon,
  eyeOff: VisibilityOffIcon,
  sensor: AltRouteIcon,
  distributor: RecordVoiceOverIcon,
  delete: DeleteIcon,
  edit: EditIcon,
  addPerson: PersonAddAlt1Icon,
  arrowDown: KeyboardArrowDownIcon,
  arrowUp: KeyboardArrowUpIcon,
  installer: ConstructionIcon,
  user: PersonIcon,
  product: ShoppingBagOutlinedIcon,
  cloudUpload: CloudUploadIcon,
  shelfIcon: LocalCafeIcon,
  hangerIcon: PhishingIcon,
  edge: AndroidIcon,
  store: HomeIcon,
  camera: LocalSeeIcon,
  floor: AppsIcon,
  field: DensitySmallIcon,
  arrowLeft: ArrowBackIosNewIcon,
  arrowRight: ArrowForwardIosIcon,
  circleArrowDown: ArrowCircleDownOutlinedIcon,
  circleArrowUp: ArrowCircleUpOutlinedIcon,
  circleArrowLeft: ArrowCircleLeftOutlinedIcon,
  circleArrowRight: ArrowCircleRightOutlinedIcon,
  deselect: DeselectOutlinedIcon,
  glassDetails: ManageSearchOutlinedIcon,
  draw: HighlightAltOutlinedIcon,
  ptzLeft: KeyboardArrowLeftIcon,
  ptzRight: KeyboardArrowRightIcon,
  ptzUp: KeyboardArrowUpIcon,
  ptzDown: KeyboardArrowDownIcon,
  zoomIn: ZoomInIcon,
  zoomOut: ZoomOutIcon,
  rotateLeft: RotateLeftIcon,
  rotateRight: RotateRightIcon,
  play: PlayArrowIcon,
  shopper: FaceIcon,
  addAPhotoIcon: AddAPhotoIcon,
  shoppingCartIcon: ShoppingCartIcon,
  accountCircleIcon: AccountCircleIcon,
  expandIcon: ExpandIcon,
  unfoldMoreIcon: UnfoldMoreIcon,
  unfoldLessIcon: UnfoldLessIcon,
  gridViewIcon: GridViewIcon,
  splitscreenIcon: SplitscreenIcon,
  openInFullIcon: OpenInFullIcon,
  closeFullscreenIcon: CloseFullscreenIcon,
  removeIcon: RemoveIcon,
  checkBoxOutlineBlankIcon: CheckBoxOutlineBlankIcon,
  minimizeIcon: MinimizeIcon,
  volumeOffIcon: VolumeOffIcon,
  volumeMuteIcon: VolumeMuteIcon,
  scienceIcon: ScienceIcon,
  calibrationIcon: CenterFocusStrongIcon,
  bugReportIcon: BugReportIcon,
  restartAltIcon: RestartAltIcon,
  addCircleIcon: AddCircleIcon,
  doubleArrowIcon: DoubleArrowIcon,
  errorIcon: ErrorIcon,
  errorOutlineIcon: ErrorOutlineIcon,
  thumbUpIcon: ThumbUpIcon,
  sentimentVeryDissatisfiedIcon: SentimentVeryDissatisfiedIcon,
  contactSupportIcon: ContactSupportIcon,
  priorityHighIcon: PriorityHighIcon,
  fingerprintIcon: FingerprintIcon,
  gpsFixedIcon: GpsFixedIcon,
  closeIcon: CloseIcon,
  graphIcon: AssessmentIcon,
  scaleIcon: ScaleIcon,
  confirmationNumberIcon: ConfirmationNumberIcon,
  imageIcon: ImageIcon,
  textIncreaseIcon: TextIncreaseIcon,
  textDecreaseIcon: TextDecreaseIcon,
  flashlightOnIcon: FlashlightOnIcon,
  flashlightOffIcon: FlashlightOffIcon,
  lowPriorityIcon: LowPriorityIcon,
  inventoryIcon: InventoryIcon,
  contentCopyIcon: ContentCopyIcon,
  reportIcon: ReportIcon,
  volumeUpIcon: VolumeUpIcon,
  cachedIcon: CachedIcon,
  locationOffIcon: LocationOffIcon,
  powerInputIcon: PowerInputIcon,
  dashboardIcon: DashboardIcon,
  functionsIcon: FunctionsIcon,
  modelTrainingIcon: ModelTrainingIcon,
  videoStableIcon: VideoStableIcon,
  videoFileIcon: VideoFileIcon,
  palnogramIcon: DrawIcon,
  viewComfyOutlinedIcon: ViewComfyOutlinedIcon,
  brickWall: ConstructionIcon,
  devIcon: LogoDevIcon,
  pestControlIcon: PestControlIcon,
  transferWithinAStationIcon: TransferWithinAStationIcon,
  autoDeleteIcon: AutoDeleteIcon,
  signalCellularNodataIcon: SignalCellularNodataIcon,
  nextPlanIcon: NextPlanIcon,
};
